import type { ScheduledDive } from '../types/ScheduledDive';

const icsDate = (iso: string) => iso.slice(0, 10).replace(/-/g, '');

const icsEscape = (s: string) => s.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');

export const buildIcsContent = (dive: ScheduledDive, inviteUrl: string): string => {
  const dateStr = icsDate(dive.scheduledDate);
  const summary = dive.siteName || dive.charterCompany || 'Dive';
  const location = [dive.siteName, dive.charterCompany].filter(Boolean).join(', ');
  const descParts = [
    dive.notes,
    `Organizer: ${dive.ownerDisplayName}`,
    `View on New Achievement Scuba: ${inviteUrl}`,
  ].filter(Boolean);

  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//NewAchievementScuba//Calendar//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${dive.diveId}@aidivecoach`,
    `DTSTART;VALUE=DATE:${dateStr}`,
    `DTEND;VALUE=DATE:${dateStr}`,
    `SUMMARY:${icsEscape(summary)}`,
    location ? `LOCATION:${icsEscape(location)}` : '',
    `DESCRIPTION:${icsEscape(descParts.join('\\n'))}`,
    `URL:${inviteUrl}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean).join('\r\n');
};

export const downloadIcs = (dive: ScheduledDive, inviteUrl: string) => {
  const content = buildIcsContent(dive, inviteUrl);
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `dive-${dive.scheduledDate.slice(0, 10)}.ics`;
  a.click();
  URL.revokeObjectURL(url);
};
